// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// import WebpackerSvelte from "webpacker-svelte";

// import Crud from "src/components/Crud.svelte";
// WebpackerSvelte.setup({
  //   Crud
  // });

import $ from 'jquery'

// overwrite select2 CSS for ekz
import 'select2/dist/css/select2.css'
import 'stylesheets/select2-ekz'

import 'select2'

import 'popper.js'
import 'bootstrap'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css'



// document.addEventListener("turbolinks:load", function () {
document.addEventListener("DOMContentLoaded", function () {
  initialize();
})


function initialize() {

  $('[data-toggle="tooltip"]').tooltip({ placement: 'left' });

  $('#refund_request_place_id').select2({
    placeholder: "Bitte wählen Sie eine Gemeinde!",
      minimumInputLength: 1,
        language: {
          inputTooShort: function () {
            return "Suchen Sie nach PLZ oder Gemeindename...";
          },
          noResults: function () {
            return "Es wurde keine Gemeinde gefunden";
          }
    },
    ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
      url: "/places.json",
        dataType: 'json',
          quietMillis: 250,
            data: function (params) {
              return {
                query: params.term, // search term
              };
            },
      processResults: function (data, page) { // parse the results into the format expected by Select2.
        return {
          results:
            data.map(function (el) {
              return {
                id: el.id,
                text: el.zip + ' ' + el.name
              }
            })
        };
      },
      cache: true
    }
  });
  // $('[data-toggle="tooltip"]').tooltip();
}

  

// document.addEventListener('DOMContentLoaded', () => {
//   const crud = new Crud({
//     target: document.body,
//     props: {
//       name: 'Svelte'
//     }
//   });

//   window.crud = crud;
// })